(function () {
  // 26 sept 2026 — Envoie a Klaviyo le PANIER COMPLET a chaque changement, pour le flux
  // « Panier abandonne ». L'evenement Shopify « Added to Cart » ne porte qu'UN produit et jamais
  // le vehicule : impossible de reconstruire le panier depuis le courriel sans ce signal.
  // Ecoute le bus unique `mk:cart:changed` (detail.cart = /cart.js complet, cf cart-unified.js).
  // Ne fait RIEN d'autre : aucune ecriture dans le panier, aucune dependance d'ordre de chargement.
  if (window.mkKlaviyoCartReady) return;
  window.mkKlaviyoCartReady = true;

  var EVENT_NAME = 'Matrikar Cart Updated';
  var ORIGIN = 'https://matrikar.com';
  // Lignes qui ne sont pas « le produit » : cadeau, option de personnalisation, ancien cadeau.
  var ADDON_TYPES = ['Car Accessories', 'Personalization', 'Trunk Organizers', 'Gabarit interne'];
  // Proprietes de ligne qu'on ne recopie pas dans le lien (bruit de suivi).
  var SKIP_PROPS = ['_visitor_id'];
  var lastSignature = '';

  function isAddon(item) {
    var p = item.properties || {};
    if (p._free_gift || p._mk_perso_addon) return true;
    return ADDON_TYPES.indexOf(item.product_type) !== -1;
  }

  function b64url(obj) {
    var json = JSON.stringify(obj);
    var bin = unescape(encodeURIComponent(json)); // UTF-8 (« Électrique », « 5 places »)
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_');
  }

  function absUrl(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return ORIGIN + u;
    return u;
  }

  function cleanProps(p) {
    var out = {};
    var n = 0;
    for (var k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      if (SKIP_PROPS.indexOf(k) !== -1) continue;
      if (p[k] === '' || p[k] === null || p[k] === undefined) continue;
      if (n >= 25) break; // limite Shopify des liens de panier
      out[k] = String(p[k]);
      n++;
    }
    return out;
  }

  function build(cart) {
    var items = (cart && cart.items) || [];
    var main = [];
    for (var i = 0; i < items.length; i++) if (!isAddon(items[i])) main.push(items[i]);
    if (!main.length) return null; // panier vide, ou seulement le cadeau / l'option

    // Ligne principale = le premier tapis qui porte un vehicule, sinon le premier vrai produit.
    // Le lien Shopify n'attache les proprietes qu'au PREMIER produit : c'est donc elle qui passe en tete.
    var primary = main[0];
    for (var j = 0; j < main.length; j++) {
      if ((main[j].properties || {}).Vehicle) { primary = main[j]; break; }
    }
    var ordered = [primary];
    for (var m = 0; m < items.length; m++) if (items[m] !== primary) ordered.push(items[m]);

    var pairs = [];
    for (var o = 0; o < ordered.length; o++) pairs.push(ordered[o].variant_id + ':' + ordered[o].quantity);
    var props = cleanProps(primary.properties || {});
    var recovery = ORIGIN + '/cart/' + pairs.join(',') + '?storefront=true';
    if (Object.keys(props).length) recovery += '&properties=' + b64url(props);

    var pp = primary.properties || {};
    var lines = [];
    for (var q = 0; q < items.length; q++) {
      var it = items[q];
      var ip = it.properties || {};
      lines.push({
        title: it.product_title,
        variant: it.variant_title || '',
        variant_id: it.variant_id,
        quantity: it.quantity,
        price: it.final_line_price / 100,
        image: absUrl(it.image),
        product_type: it.product_type || '',
        is_gift: !!ip._free_gift,
        is_addon: isAddon(it),
        vehicle: ip.Vehicle || '',
        vehicle_year: ip['Vehicle Year'] || '',
        personalization: ip.Personalization || ip._mk_perso_label || ''
      });
    }

    return {
      RecoveryURL: recovery,
      ProductName: primary.product_title,
      VariantName: primary.variant_title || '',
      ImageURL: absUrl(primary.image),
      Vehicle: pp.Vehicle || '',
      VehicleYear: pp['Vehicle Year'] || '',
      HasGift: items.some(function (x) { return !!(x.properties || {})._free_gift; }),
      ItemCount: cart.item_count,
      Items: lines,
      $value: cart.total_price / 100,
      $currency: cart.currency
    };
  }

  // Copie du DERNIER panier sur la fiche client : un courriel lit la fiche au moment de l'envoi,
  // alors que l'evenement fige le panier au moment ou le flux a demarre.
  function profileProps(payload) {
    return {
      'Matrikar Cart URL': payload ? payload.RecoveryURL : '',
      'Matrikar Cart Product': payload ? payload.ProductName : '',
      'Matrikar Cart Variant': payload ? payload.VariantName : '',
      'Matrikar Cart Image': payload ? payload.ImageURL : '',
      'Matrikar Cart Vehicle': payload ? payload.Vehicle : '',
      'Matrikar Cart Vehicle Year': payload ? payload.VehicleYear : '',
      'Matrikar Cart Has Gift': payload ? payload.HasGift : false,
      'Matrikar Cart Items': payload ? payload.Items : [],
      'Matrikar Cart Value': payload ? payload.$value : 0,
      'Matrikar Cart Currency': payload ? payload.$currency : '',
      'Matrikar Cart Updated': new Date().toISOString()
    };
  }

  function updateProfile(payload) {
    var k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function' || typeof k.identify !== 'function') return;
    k.isIdentified().then(function (yes) {
      if (yes) k.identify(profileProps(payload));
    }).catch(function () {});
  }

  function send(cart) {
    try {
      if (!cart || !cart.items) return;
      var payload = build(cart);
      var sig = payload ? payload.RecoveryURL + '|' + payload.$value : 'empty';
      if (sig === lastSignature) return; // meme panier, pas de doublon
      var wasEmpty = lastSignature === '' || lastSignature === 'empty';
      lastSignature = sig;
      if (!payload) {
        if (!wasEmpty) updateProfile(null); // panier vide : on efface la copie
        return;
      }
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', EVENT_NAME, payload]);
      updateProfile(payload);
    } catch (e) { /* ne jamais casser le panier pour un suivi */ }
  }

  document.addEventListener('mk:cart:changed', function (e) {
    send(e && e.detail && e.detail.cart);
  });

  window.mkKlaviyoCartBuild = build; // lecture seule, pour verification
})();
